import * as Views from "./views";
import * as Wizards from "./wizards";

const Module = {
    name: "sources",
    defaultRoutePath: "/advertisings/source",
    menuItemScope: "operations",
    menuItemName: "source",

    routes: [
        {
            path: "/advertisings/source",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "budgetandgoals",
            Component: Wizards.BudgetAndGoals,
        },
    ],

}

export default Module;
